import { defineAppConfig } from "@app/shared";

/**
 * Configuration de l'app. C'est le seul fichier par lequel une app se decrit :
 * ni le backend, ni le frontend, ni les Dockerfiles ne se modifient pour changer
 * une marque, un domaine ou une duree de conservation.
 *
 * Ce qui ne peut pas vivre ici parce que c'est secret (mots de passe, jetons, cles)
 * vit dans le .env de l'hote, jamais dans git.
 */
export const appConfig = defineAppConfig({
  slug: "livre-jeu",
  name: "Livre-jeu",
  description:
    "L'appli compagnon des livres-jeux du Lab : elle garde votre partie et vous donne la page à lire.",
  domain: "livre-jeu.petitlab.fr",
  // L'adresse du Lab, deja en service : une adresse publiee dans les pages legales doit
  // recevoir le courrier, et aucune boite ni alias `livre-jeu@` n'a ete cree (convention du
  // playbook domaine-et-mail ; recommandation du geste gestes/identite-editeur).
  contactEmail: "lab@petitlab.fr",
  locale: "fr-FR",
  features: {
    auth: false,
    billing: false,
    llm: false,
  },
  // Durees de conservation RGPD, en jours. Elles sont affichees telles quelles dans
  // la politique de confidentialite : les changer change la page.
  retention: {
    accountDays: 1095,
    analyticsDays: 395,
    logDays: 30,
    attributionDays: 30,
  },
  /**
   * Identite publiee dans les pages legales. Le template ne peut pas la connaitre :
   * elle engage une personne reelle. Ces valeurs arrivent vides **a dessein** et se voient
   * (avertissement en tete des pages legales, liste dans `/metrics`, avertissement dans
   * les journaux au demarrage). A remplir avant la mise en ligne de l'app.
   */
  legal: {
    publisher: {
      name: "Nicolas DODEMANT",
      legalForm: "Entrepreneur individuel (EI), micro-entreprise",
      address: "5 bis allée de Champlong, 37210 Rochecorbon, France",
      phone: "+33 6 29 10 33 56",
      // Vide = l'adresse de contact de l'app ci-dessus est publiee.
      email: "nicolas.dodemant@gmail.com",
      registration: "SIREN 753 448 695, inscrit au Registre national des entreprises",
      // Vide si l'editeur n'est pas assujetti a la TVA.
      vatNumber: "",
      // Exige des que l'app vend. Franchise en base : "TVA non applicable, article 293 B du CGI".
      vatNotice: "TVA non applicable, article 293 B du CGI",
      publicationDirector: "Nicolas DODEMANT",
    },
    // Meme identite que la console (apps/lab/app.config.ts, geste gestes/identite-editeur) :
    // serveur dedie fortress, loue a OneProvider et installe a Paris.
    host: {
      name: "OneProvider (BrainStorm Network Inc.)",
      address: "3275 avenue Francis-Hughes, Laval (Québec) H7L 5A5, Canada",
      phone: "+1 514 286 0253",
    },
    // Mediateur de la consommation : obligatoire des que l'app vend a des particuliers.
    mediator: {
      name: "",
      address: "",
      url: "",
    },
    // Date de derniere mise a jour des pages legales, au format AAAA-MM-JJ.
    updatedAt: "2026-10-03",
  },
});
